<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <!--
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on">Seja nosso Patrocinador</v-btn>
      </template>
      -->
    <v-card>
      <v-toolbar dark color="secundary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Redes Sociais</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="dialog = false">Fechar</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container>

        <RedesSociais />

      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

import RedesSociais from '@/components/Cards/RedesSociais.vue'

export default {
  components: { RedesSociais },
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
    };
  },
  watch: {
    IsRedesSociais(val) {
      if (!val) return;

      if (val == true) {
        this.dialog = true;

        this.$store.commit("setIsRedesSociais", false);
      }
    }
  },
  computed: mapState([
    // map this.count to store.state.count
    "IsRedesSociais",
    "IsMobile"
  ])
};
</script>

<style></style>
